<template>
    <v-card class="deposit-form investorAccountAuth" :color="$vuetify.theme.dark ? 'transparent' : 'transparent'">
        <v-row>
            <v-col md="5" sm="12">
                <fieldset>
                    <legend>Investor Password</legend>
                    <v-text-field label="**************" v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? 'text' : 'password'" counter
                        @click:append="show1 = !show1" single-line solo hide-details
                        class="custom-select"></v-text-field>
                </fieldset>
                <div class="tick-mark justify-start">
                    <span>
                        <v-icon small :class="hasMinimumLength
                                ? 'text--green'
                                : 'text--primary'
                            ">mdi mdi-check</v-icon>8 Characters
                    </span>
                    <span>
                        <v-icon small :class="hasLowerCase ? 'text--green' : 'text--primary'
                            ">mdi mdi-check</v-icon>1 Lowercase
                    </span>
                    <span>
                        <v-icon small :class="hasUpperCase ? 'text--green' : 'text--primary'
                            ">mdi mdi-check</v-icon>1 Uppercase
                    </span>
                    <span>
                        <v-icon small :class="hasDigit ? 'text--green' : 'text--primary'">mdi mdi-check</v-icon>1 Digit
                    </span>
                    <span>
                        <v-icon small :class="hasSpecialCharacter
                                ? 'text--green'
                                : 'text--primary'
                            ">mdi mdi-check</v-icon>1 Special Character
                    </span>
                </div>
                <fieldset>
                    <legend>Confirm Password</legend>
                    <v-text-field v-model="password2" :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="show2 ? 'text' : 'password'" counter @click:append="show2 = !show2"
                        label="Confirm Password" single-line solo hide-details class="custom-select"></v-text-field>
                </fieldset>
                <span v-if="error.passwordError" class="error-message">
                    {{ error.passwordError }}
                </span>

                <fieldset class="mt-6" v-if="this.$route.query.type == 2">
                    <legend>Copy Ratio</legend>
                    <v-select ref="accountTypeSelect" v-model="selectedRatio" solo :items="copyTradeAsRatio"
                        item-value="id" item-text="ratio_type_display" append-icon="mdi-chevron-down"
                        label="Select Account Type" class="custom-select" single-line hide-details="auto" @change="handleAccountChange">
                    </v-select>
                </fieldset>

                <v-card-actions class="pa-0">
                    <v-btn class="ma-0 text-capitalize btn-account" color="greenMain" tile elevation="0"
                        @click="handleSumbit" :disabled="!password || password !== password2 || loading"
                        :loading="loading">
                        Create Account
                    </v-btn>
                </v-card-actions>
            </v-col>

            <v-col md="5" sm="12" class="mx-auto" v-if="this.$route.query.type == 2">
                <v-card class="elevation-0 rounded-0 deposit-form-card mt-2"
                    :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
                    <v-card-actions>
                        <div class="trade-status">
                            <div class="trade-number p-0">
                                <v-text> 
                                    <v-icon color="#4A5D73" class="mr-2">mdi-help-circle-outline</v-icon>
                                    What "{{ selectedRatioText }}" Means ?
                                </v-text>
                                <span style="color:#4A5D73; margin-left: 35px; margin-top: 7px;">
                                    <span v-if="selectedRatioText == 'Proportional to equity'">
                                        {{ selectedRatioTextDiscriptions1 }}
                                    </span>
                                    <span v-else>
                                        {{ selectedRatioTextDiscriptions2 }}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-card>
</template>
<script>
import { mapActions } from "vuex";
import { MAM__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            show1: false,
            show2: false,
            loading: false,
            password: "",
            password2: "",
            selectedRatio: 0,
            selectedRatioText: "Proportional to equity",
            selectedRatioTextDiscriptions1: "Trades will be copied Proportional to equity of investor's account.",
            selectedRatioTextDiscriptions2: "",
            error: {
                passwordError: null,
            },
            hasMinimumLength: false,
            hasLowerCase: false,
            hasUpperCase: false,
            hasDigit: false,
            hasSpecialCharacter: false,
            copyTradeAsRatio: [
                { id: 0, ratio_type_display: "Proportional to equity" },
                { id: 1, ratio_type_display: "1X" },
                { id: 2, ratio_type_display: "2X" },
                { id: 3, ratio_type_display: "3X" },
                { id: 4, ratio_type_display: "4X" },
                { id: 5, ratio_type_display: "5X" },
            ],
        };
    },
    computed: {
        allConditionsMet() {
            return (
                this.hasMinimumLength &&
                this.hasLowerCase &&
                this.hasUpperCase &&
                this.hasDigit &&
                this.hasSpecialCharacter &&
                this.password &&
                this.password2
            );
        },
    },
    watch: {
        password: function () {
            this.hasMinimumLength = this.password.length >= 8;
            this.hasLowerCase = /.*[a-z].*/.test(this.password);
            this.hasUpperCase = /.*[A-Z].*/.test(this.password);
            this.hasDigit = /.*\d.*/.test(this.password);
            this.hasSpecialCharacter = /.*[@$!%*#?&^_-].*/.test(this.password);
        },
    },
    methods: {
        ...mapActions("mam", [MAM__ACTIONS.OPENNEWINVESTORACCOUNT]),

        handleAccountChange(id) {
            const selected = this.copyTradeAsRatio.find(acc => acc.id === id);
            this.selectedRatioText = selected ? selected.ratio_type_display : "";
            this.selectedRatioTextDiscriptions2 = `Trades will be copied in ${this.selectedRatioText} ratio as the manager's trades.`;
        },    

        async handleSumbit() {
            this.loading = true;
            this.error.passwordError = null;

            if (!this.password) {
                this.error.passwordError = "Password field is required";
                this.loading = false;
                return;
            } else if (this.password !== this.password2) {
                this.error.passwordError = "Passwords do not match";
                this.loading = false;
                return;
            }

            try {
                const data = {
                    newInvestorAccount: {
                        investor_password: this.password,
                        manager_account_id: this.$route.query.id,
                        acc_type_ratio: this.selectedRatioText,
                    },
                };

                await this[MAM__ACTIONS.OPENNEWINVESTORACCOUNT](data);
                this.password = "";
                this.password2 = "";

            } catch (error) {
                console.error('Deposit submission error:', error.message);
                this.error.passwordError = "Something went wrong. Please try again.";
            } finally {
                this.loading = false;
            }
        }

    },
};
</script>
